import { Box, Button, Grid, IconButton, Stack, Tooltip, Modal } from "@mui/material";
import { useState, useRef } from "react";
import { Cropper } from 'react-cropper'
import "cropperjs/dist/cropper.css";
import Rotate90DegreesCcwOutlinedIcon from '@mui/icons-material/Rotate90DegreesCcwOutlined';
import Rotate90DegreesCwOutlinedIcon from '@mui/icons-material/Rotate90DegreesCwOutlined';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { useParams } from "react-router-dom";

const ImageEditor = ({ img_url, index, setOpenModal, handleEditedImage, single }) => {
    const cropperRef = useRef(null);

    const { object_id } = useParams();

    const [cropData, setCropData] = useState('#')
    const onRotate = direction => () => {
        let angle = 0;
        let angleConfig = {
            left: -90,
            right: 90
        }
        angle = angleConfig[direction] ?? 0;
        cropperRef.current.cropper.rotate(angle);
    }

    const onReset = () => {
        const cropper = cropperRef.current.cropper;
        cropper.reset();
        setCropData('#');
    };
    function blobToFile(blob, fileName) {
        // Convert blob to file by creating a new File object
        const file = new File([blob], fileName, { type: blob.type });
        return file;
    }

    const getCropData = () => {
        if (typeof cropperRef.current?.cropper !== "undefined") {
            setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
        }
    };


    const handleSaveImageCropper = () => {
        const data = cropperRef.current.cropper.getCroppedCanvas();
        data.toBlob(blob => {
            const file = new File([blob],
                `${object_id ? `hotel_obj_${object_id}` : ''}${single ? '_single_' : ''}edited_image_${index}.jpg`,
                { type: blob.type });
            handleEditedImage(file, index);
            setOpenModal(false); // Close the modal after saving the image
        });
    };

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ px: 2, height: '50vh' }}>
                    <CropperBlock url={img_url} refValue={cropperRef} />
                </Grid>
                <Grid item container xs={12} className='cropper-controls flex abs-center'>
                    <Stack direction='row' spacing={2}>
                        <Tooltip title='Обрізати'>
                            <IconButton onClick={getCropData}>
                                <CheckOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='Поворот вліво'>
                            <IconButton onClick={onRotate('left')}>
                                <Rotate90DegreesCcwOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='Поворот право'>
                            <IconButton onClick={onRotate('right')}>
                                <Rotate90DegreesCwOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='Скасувати'>
                            <IconButton onClick={onReset}>
                                <ChangeCircleOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </Grid>
                <Grid item container>
                    <Grid item xs={6}>
                        Результат
                    </Grid>
                    <Grid item xs={6}>
                        Попередній перегляд
                    </Grid>
                </Grid>
                <Grid item container xs={12} sx={{ overflow: 'auto' }}>
                    <Grid item xs={6} container direction='column'>
                        <Box sx={{
                            height: '250px',
                            width: '100%',
                            overflow: 'auto', display: 'inline-block', boxSizing: 'border-box',
                            p: 1
                        }}>
                            {cropData !== '#' && (
                                <img style={{ width: "100%" }} src={cropData} alt="" />)}
                        </Box>
                    </Grid>
                    <Grid item xs={6} sx={{ display: 'inline-block', boxSizing: 'border-box', p: 1, }}>
                        <Box
                            id="img-preview"
                            sx={{ width: "100%", float: "none", height: "250px", overflow: 'hidden' }}
                        />
                    </Grid>

                </Grid>
                <Grid item container xs={12} spacing={2}>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant='contained'
                            disabled={cropData === '#'}
                            onClick={handleSaveImageCropper}
                        >
                            зберегти
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant='outlined'
                            onClick={() => setOpenModal(false)}
                        >
                            скасувати
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
const CropperBlock = ({ url, refValue }) => {
    return (
        <>
            <Cropper
                src={url}
                style={{ height: '100%', width: '100%' }}
                ref={refValue}
                scalable
                preview="#img-preview"
                viewMode={1}
                guides={true}
                background={false}
                responsive={true}
                checkOrientation={false}
                autoCropArea={1}
                initialAspectRatio={16 / 9}
                dragMode='move'
            />

        </>
    )
}
export default ImageEditor;